import { render, staticRenderFns } from "./ThroughputChip.vue?vue&type=template&id=a830924a&scoped=true"
import script from "./ThroughputChip.vue?vue&type=script&lang=js"
export * from "./ThroughputChip.vue?vue&type=script&lang=js"
import style0 from "./ThroughputChip.vue?vue&type=style&index=0&id=a830924a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a830924a",
  null
  
)

export default component.exports